import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { BrandColors } from '../../constants/brandColors';

export const ViewAllStyles = makeStyles()((theme: Theme) => ({
  root: {
    textAlign: 'center',
    width: '100%',
    minHeight: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    background: theme.palette.background.default,
  },
  bgWhite: {
    backgroundColor: BrandColors.white,
  },
  inputBG: {
    backgroundColor: theme.palette.background.paper,
    border: `2px solid ${theme.palette.borderColor?.main || BrandColors.transparent}`,
    color: theme.palette.default?.main,
  },
  content: {
    maxWidth: '46.87rem',
    minWidth: '21.25rem',
    width: '95%',
  },
  errorText: {
    color: BrandColors.red39,
  },
  errorAlert: {
    margin: '0.5rem 1rem',
    color: BrandColors.red39,
    textAlign: 'left',
  },
  heading: {
    outline: 'none',
    marginTop: '2rem',
    marginBottom: '1.12rem',
    color: theme.palette.default?.main || BrandColors.black,
  },
  sectionTitle: {
    fontSize: '1.12rem',
    marginBottom: '0.5rem',
    color: theme.palette.primary.main,
    marginTop: '0.5rem',
    [theme.breakpoints.up('md')]: {
      flexGrow: 1,
    },
  },
  section: {
    display: 'inline-flex',
    padding: '0rem 1rem 0rem 0.5rem',
    [theme.breakpoints.up('md')]: {
      width: '100%',
    },
  },
  ratingHelpIcon: {
    padding: 0,
    marginBlock: '0.75rem',
    color: theme.palette.default?.main || BrandColors.black,
    [theme.breakpoints.up('md')]: {
      marginBlock: 0,
    },
  },
  listItem: {
    display: 'flex',
    flexDirection: 'column',
    width: 'inherit',
  },
  questionBlock: {
    display: 'flex',
    flexDirection: 'row',
    width: 'inherit',
    marginTop: '1rem',
  },
  divider: {
    opacity: 0.4,
    backgroundColor: `${theme.palette.default?.main || BrandColors.black} !important`,
  },
  question: {
    flexGrow: 9,

    display: 'inline-flex',
    '& > p': {
      color: theme.palette.default?.main || BrandColors.black,
    },
  },
  answer: {
    flexGrow: 1,
    minWidth: '1.5rem',
    maxWidth: '1.5rem',
    textAlign: 'center',
    '& > p': {
      color: theme.palette.default?.main || BrandColors.black,
    },
  },
  font1rem: {
    fontSize: '1rem',
  },
  bold: {
    fontWeight: 700,
  },
  competencyHelpIcon: {
    padding: '0',
    marginInline: '0.75rem',
    margin: '0 0.75rem 0 0.75rem',
    color: theme.palette.default?.main || BrandColors.black,
  },
  compPopper: {
    zIndex: 251,
    marginRight: '0.5rem',
    marginTop: '-0.3rem',
  },
  nonCompPopper: {
    zIndex: 251,
    marginLeft: '0.5rem',
    marginTop: '0',
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'block',
    },
  },
  compPopperContent: {
    height: 'fit-content',
    width: 'fit-content',
    maxWidth: '15.75rem',
    padding: '1rem',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.background.default,
    borderRadius: '0.5rem',
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  },
  arrow: {
    [theme.breakpoints.between('sm', 'md')]: {
      display: 'none !important',
    },
    color: theme.palette.primary.main,
    width: '0.71em',
    height: '1em',
    right: '-0.71em',
    top: '0.5rem',
    overflow: 'hidden',
    position: 'absolute',
    boxSizing: 'border-box',
    '&::before': {
      content: '""',
      margin: 'auto',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundColor: 'currentColor',
      transform: 'rotate(45deg)',
      transformOrigin: '0 0',
    },
  },
  arrowLeft: {
    right: 'none',
    left: '-0.71em',
    '&::before': {
      transformOrigin: '100% 100%',
    },
  },
  displayFlex: {
    display: 'flex',
  },
  closeIcon: {
    padding: 0,
    height: 'fit-content',
  },
  closeIconIE: {
    padding: 0,
    height: 'fit-content',
    '@media screen and (-ms-high-contrast:active), (-ms-high-contrast:none)': {
      position: 'absolute',
      right: '1rem',
    },
  },
  compPopperHeading: {
    marginBottom: '1rem',
    flexGrow: 1,
    fontSize: '0.87rem',
  },
  font14: {
    fontSize: '0.87rem',
  },
  flexColumn: {
    flexDirection: 'column',
  },
  ADAnswers: {
    marginTop: '1.5rem',
    marginBottom: '0.5rem',
  },
  finalDivider: {
    display: 'block',
    marginTop: '1rem',
  },
  displayNone: {
    display: 'none',
  },
  flexgrow1: {
    flexGrow: 1,
    '& > p': {
      color: theme.palette.default?.main || BrandColors.black,
    },
  },
  maxwidth50: {
    maxWidth: '50%',
    '& > p': {
      color: theme.palette.default?.main || BrandColors.black,
    },
  },
  listStyle: {
    paddingLeft: '1rem !important',
    paddingRight: '1rem !important',
    '@media screen and (device-aspect-ratio: 40/71) and (device-width : 320px)': {
      paddingLeft: '1.25rem !important',
      paddingRight: '1rem !important',
    },
  },
  commentBox: {
    width: '100%',
    marginTop: '1rem',
    overflow: 'auto !important',
    minHeight: '7.25rem !important',
    resize: 'none',
    border: '0.063rem solid',
    fontFamily: 'Open Sans',
    borderColor: theme.palette.primary.contrastText,
    boxShadow: `0rem 0.5rem 1.25rem ${BrandColors.blackWithOpacity08}`,
    boxSizing: 'border-box',
    padding: '0.625rem 0.75rem',
    fontSize: '0.875rem',
    background: theme.palette.background.paper,
    color: theme.palette.default?.main || BrandColors.black,
    [theme.breakpoints.up('sm')]: {
      fontSize: '1rem',
      maxWidth: '45.25rem',
    },
  },
  width100: {
    width: '100%',
  },
  marginAuto: {
    margin: '0 auto',
  },
  toolTipIcon: {
    fontSize: '1.5rem',
    marginTop: '-1px',
    marginLeft: '8px',
    [theme.breakpoints.up('sm')]: {
      fontSize: '2rem',
      margin: '0px',
    },
  },
  competencyName: {
    padding: '1.25rem 0',
    fontWeight: 700,
    fontSize: '1rem',
    color: theme.palette.default?.main || BrandColors.black,
    textAlign: 'center',
  },
}));
